import PropTypes from 'prop-types';

const fmt = value => {
  if (value == null) return <span className="text-gray-300">—</span>;
  return Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 });
};

const CostHeader = ({ label, unit }) => (
  <th className="py-2 px-3 font-medium text-gray-600 whitespace-nowrap">
    {label}
    {unit && <span className="block text-xs font-normal text-gray-400">{unit}</span>}
  </th>
);

CostHeader.propTypes = {
  label: PropTypes.string.isRequired,
  unit: PropTypes.string,
};

const DataviewerTable = ({ rows, metadataKeys, costUnits }) => {
  const hasTech = metadataKeys?.includes('tech');

  if (!rows.length) {
    return <p className="text-sm text-gray-400 py-8 text-center">No data matches the current filters.</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left text-sm border-collapse">
        <thead>
          <tr className="border-b bg-gray-50">
            <th className="py-2 px-3 font-medium text-gray-600">Source</th>
            <th className="py-2 px-3 font-medium text-gray-600">Region</th>
            {hasTech && <th className="py-2 px-3 font-medium text-gray-600">Tech</th>}
            <th className="py-2 px-3 font-medium text-gray-600">Continent</th>
            <CostHeader label="Capital Cost" unit={costUnits?.capital_cost} />
            <CostHeader label="Fixed O&M" unit={costUnits?.fixed_om_cost} />
            <CostHeader label="Variable O&M" unit={costUnits?.variable_om_cost} />
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} className="border-b hover:bg-gray-50 transition-colors">
              <td className="py-2 px-3 text-gray-700">
                {row.citation_url ? (
                  <a href={row.citation_url} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">
                    {row.source}
                  </a>
                ) : (
                  row.source
                )}
              </td>
              <td className="py-2 px-3">{row.region ?? <span className="text-gray-300">—</span>}</td>
              {hasTech && <td className="py-2 px-3">{row.tech ?? <span className="text-gray-300">—</span>}</td>}
              <td className="py-2 px-3 text-gray-500">{row.continent ?? <span className="text-gray-300">—</span>}</td>
              <td className="py-2 px-3 font-mono">{fmt(row.capital_cost)}</td>
              <td className="py-2 px-3 font-mono">{fmt(row.fixed_om_cost)}</td>
              <td className="py-2 px-3 font-mono">{fmt(row.variable_om_cost)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

DataviewerTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  metadataKeys: PropTypes.arrayOf(PropTypes.string),
  costUnits: PropTypes.objectOf(PropTypes.string),
};

export default DataviewerTable;
